import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { verificationApi } from '../api/verificationApi';
import { ivKeys } from '../queryKeys';

export function useConnections() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const query = useQuery({
    queryKey: ivKeys.connections(locationId),
    queryFn: () => verificationApi.getConnections(locationId || undefined),
    // Without a location the provider identity would show the env fallback
    // for a moment before the real one loads.
    enabled: !!locationId,
  });

  return { ...query, connections: query.data ?? null };
}

export function useRefreshCodeMap() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => verificationApi.refreshCodeMap(locationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ivKeys.connectionsPrefix() });
    },
  });
}

export function useSyncOpenDental() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (days?: number) => verificationApi.syncOpenDental(locationId, days),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ivKeys.worklistPrefix(locationId) });
      queryClient.invalidateQueries({ queryKey: ivKeys.metrics(locationId) });
      queryClient.invalidateQueries({ queryKey: ivKeys.connectionsPrefix() });
    },
  });
}

export function useStediDiagnostics() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useMutation({ mutationFn: () => verificationApi.runStediDiagnostics(locationId, true) });
}

export function useRerunFailed() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => verificationApi.rerunFailed(locationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ivKeys.worklistPrefix(locationId) });
      queryClient.invalidateQueries({ queryKey: ivKeys.metrics(locationId) });
    },
  });
}
